import { useState, useEffect } from "react";
import { Button, TextField, Grid, InputAdornment } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setDialog,
  resetForm,
  resetCheckPrice,
  Orders,
} from "../../../../app/slices/orderSlice";
import { Controller, useForm } from "react-hook-form";
import { SelectSupplier } from "../../../../components/Selectors/SelectSupplier";
import { SelectItem } from "../../../../components/Selectors/SelectItems";
import {
  HiOutlineDocumentText,
  HiOutlineCube,
  HiOutlineBanknotes,
  HiOutlineCalculator,
} from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";
import { BRAND, BRAND_DARK } from "../../../../components/MobileList";

const OrdersForm = () => {
  const _Orders = useSelector((state) => state.orders.order);
  const _checkPrice = useSelector((state) => state.orders.checkSellingPrice);

  const isAdd = _Orders.form.id ? false : true;
  const { control, reset, handleSubmit, setValue, getValues } = useForm({
    defaultValues: _Orders.form,
  });

  const [saving, setSaving] = useState(false);

  const onSubmit = async (data) => {
    setSaving(true);
    try {
      await dispatch(
        Orders.addSupplierOrder({
          ...data,
          item_id: data.item_id.id,
          supplier_id: data.supplier_id.id,
        })
      );
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    reset({ ..._Orders.form });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_Orders.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
      dispatch(resetCheckPrice());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setDialog());
  };

  const handleCheckPrice = () => {
    dispatch(
      Orders.checkSellingPrice({
        item_id: getValues("item_id")?.id,
        count: getValues("count"),
      })
    );
  };

  return (
    <FormDialog
      open={_Orders.dialog}
      onClose={handleClose}
      icon={<HiOutlineDocumentText />}
      title={isAdd ? "إضافة فاتورة جديدة" : "تعديل الفاتورة"}
      subtitle={
        isAdd
          ? "اختر المنتج والمورد ثم أدخل تفاصيل الشراء"
          : "قم بتحديث تفاصيل الفاتورة ثم احفظ التغييرات"
      }
      maxWidth="md"
      onSubmit={handleSubmit(onSubmit)}
      saving={saving}
    >
      <SectionCard icon={<HiOutlineCube />} title="معلومات الفاتورة">
        <Grid item xs={12} sm={6}>
          <Controller
            name="item_id"
            control={control}
            render={({ field }) => (
              <SelectItem
                required
                value={field.value}
                onChange={(e, newValue) => {
                  setValue("item_id", newValue);
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="supplier_id"
            control={control}
            render={({ field }) => (
              <SelectSupplier
                required
                value={field.value}
                onChange={(e, newValue) => {
                  setValue("supplier_id", newValue);
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="count"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="العدد"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>

      <SectionCard icon={<HiOutlineCalculator />} title="فحص سعر الشراء">
        <Grid item xs={12} sm={4}>
          <Button
            onClick={handleCheckPrice}
            variant="contained"
            fullWidth
            sx={{
              height: 40,
              bgcolor: BRAND,
              boxShadow: "0 4px 12px rgba(12,134,182,0.3)",
              "&:hover": { bgcolor: BRAND_DARK },
            }}
          >
            فحص السعر
          </Button>
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            size="small"
            label="سعر الشراء الكلي"
            fullWidth
            value={_checkPrice.total?.toLocaleString() ?? ""}
            InputProps={{
              readOnly: true,
              startAdornment: (
                <InputAdornment position="start">IQD</InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            size="small"
            label="سعر الشراء المفرد"
            fullWidth
            value={_checkPrice.single?.toLocaleString() ?? ""}
            InputProps={{
              readOnly: true,
              startAdornment: (
                <InputAdornment position="start">IQD</InputAdornment>
              ),
            }}
          />
        </Grid>
      </SectionCard>

      <SectionCard icon={<HiOutlineBanknotes />} title="المبالغ والملاحظات">
        <Grid item xs={12} sm={6}>
          <Controller
            name="price"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="سعر بيع المفرد"
                fullWidth
                {...field}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">IQD</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="cash_paid"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="المبلغ المدفوع"
                fullWidth
                {...field}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">IQD</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="note"
            control={control}
            render={({ field }) => (
              <TextField
                size="small"
                multiline
                rows={2}
                label="الملاحظة"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default OrdersForm;
